import { useMutation, useQueries, useQuery, useQueryClient } from '@tanstack/react-query';

import { createTemplates } from '../../Repositories';
import { useUserPermissions } from '../Hook/useUserPermissions';

const templateRep = createTemplates();

export function useTemplateGetQuery(options) {
  const { canPerformAdminActions } = useUserPermissions();
  return useQuery(['templateGetQuery'], () => templateRep.getAllTemplates(), {
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    // Auto-disable for restricted users unless explicitly enabled
    enabled: canPerformAdminActions,
    ...options,
  });
}

export function useTemplateGetQueryById(reqParams, options) {
  return useQuery(
    ['templateGetQueryById', reqParams],
    () => templateRep.getTemplateById(reqParams),
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      ...options,
    }
  );
}
export function useTemplatesGetQueryByIds(templateIDs = []) {
  return useQueries({
    queries: templateIDs.map((id) => ({
      queryKey: ['templateGetQueryById', { reqId: id }],
      queryFn: () => templateRep.getTemplateById({ reqId: id }),
      enabled: !!id,
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    })),
  });
}

export function useAddTemplateQuery() {
  const queryClient = useQueryClient();
  return useMutation(['templatePostQuery'], (args) => templateRep.postTemplate(args), {
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries(['templateGetQuery']);
    },
  });
}

export function useUpdateTemplateQueryById() {
  const queryClient = useQueryClient();
  return useMutation(['templatePutQueryById'], (args) => templateRep.putTemplateById(args), {
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries(['templateGetQuery']);
    },
  });
}

export function useDeleteTemplateQueryById() {
  const queryClient = useQueryClient();
  return useMutation(['templateDeleteQueryById'], (args) => templateRep.deleteTemplateById(args), {
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries(['templateGetQuery']);
    },
  });
}

export function useGenerateOfferLetter(req) {
  return useMutation(['generateOfferLetter', req], () => templateRep.generateOfferLetter(req), {
    retry: false,
  });
}

export function useGetRejectedTemplatePlaceHolders(templateType, options) {
  return useQuery(
    ['GetRejectedTemplatePlaceHolders', templateType],
    () => templateRep.getPlaceholders(templateType),
    {
      enabled: false,
      ...options,
    }
  );
}
